import { Navigate, Route, Routes } from 'react-router-dom'

import { useSession } from './api/queries'
import { Shell } from './components/Shell'
import { LoginPage } from './routes/LoginPage'
import { OverviewPage } from './routes/OverviewPage'
import { QueuePage } from './routes/QueuePage'
import { InvestigationPage } from './routes/InvestigationPage'
import { HuntPage } from './routes/HuntPage'
import { CoveragePage } from './routes/CoveragePage'
import { InventoryPage } from './routes/InventoryPage'
import { VulnerabilitiesPage } from './routes/VulnerabilitiesPage'
import { CompliancePage } from './routes/CompliancePage'
import { ReportsPage } from './routes/ReportsPage'
import { AdminPage } from './routes/AdminPage'
import { DashboardPage } from './routes/DashboardPage'
import { RulesPage } from './routes/RulesPage'
import { ResponsePage } from './routes/ResponsePage'
import { GuidePage } from './routes/GuidePage'

export default function App() {
  const session = useSession()

  if (session.isLoading) {
    return (
      <p className="empty" role="status">
        Checking your session…
      </p>
    )
  }

  // Not signed in, or signed in but stopped at the second factor: both end at the
  // login screen, which knows which of the two it is looking at.
  const needsAuth = session.isError || !session.data || !session.data.mfa.verified
  if (needsAuth) return <LoginPage session={session.data} onSignedIn={() => session.refetch()} />

  return (
    <Shell session={session.data}>
      <Routes>
        <Route path="/" element={<Navigate to="/overview" replace />} />
        <Route
          path="/overview"
          element={
            <OverviewPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
            />
          }
        />
        <Route path="/dashboard" element={<DashboardPage session={session.data} />} />
        <Route path="/queue" element={<QueuePage session={session.data} />} />
        <Route path="/findings/:id" element={<InvestigationPage session={session.data} />} />
        <Route
          path="/hunt"
          element={
            <HuntPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route
          path="/coverage"
          element={
            <CoveragePage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
            />
          }
        />
        <Route
          path="/inventory"
          element={
            <InventoryPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route
          path="/vulnerabilities"
          element={
            <VulnerabilitiesPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route
          path="/compliance"
          element={
            <CompliancePage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
            />
          }
        />
        <Route
          path="/reports"
          element={
            <ReportsPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route
          path="/response"
          element={
            <ResponsePage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route
          path="/rules"
          element={
            <RulesPage tenants={session.data.memberships.map((membership) => membership.tenant)} />
          }
        />
        <Route
          path="/admin"
          element={
            <AdminPage
              tenants={session.data.memberships.map((membership) => membership.tenant)}
              session={session.data}
            />
          }
        />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="*" element={<p className="empty">No such page.</p>} />
      </Routes>
    </Shell>
  )
}
